<div
  class="flex flex-col md:flex-row justify-between md:items-center"
  id="stacked-bar-chart__container"
>
  <div
    class="text-2xl font-bold font-edenred text-grayscale-heavy mb-2 md:mb-0"
    id="stacked-bar-chart__title"
  >
    {{ labels?.title | transloco }}
  </div>
  @if (!config?.hideSelectType) {
    <div class="w-full md:max-w-[300px]">
      <label
        class="text-grayscale-medium text-xs font-bold pl-[12px]"
        for="timePeriod"
        >{{ labels?.multiselect | transloco }}</label
      >
      <er-multi-select
        bindLabel="label"
        bindValue="value"
        [closeOnSelect]="false"
        [searchable]="true"
        [items]="config?.items"
        [ngModel]="selectedItems"
        (ngModelChange)="changeSelectedItems($event)"
        [useTranslations]="true"
        [clearable]="false"
        [minOneRequired]="true"
        id="stacked-bar-chart__items"
      />
    </div>
  }
</div>
<div class="flex flex-col items-center space-y-5 h-[360px]">
  <canvas id="canvas-stacked-bar-chart">{{ chart }}</canvas>
</div>
<div
  class="flex flex-wrap gap-4 mt-4 mx-[20px] type-and-elements-medium text-[12px] font-[400]"
  id="stacked-bar-chart__info"
>
  <span class="mr-4 font-ubuntu">{{ labels?.legend | transloco }}</span>
  @for (item of config?.items; track item; let idx = $index) {
    @if (selectedItems.includes(item.value)) {
      <div class="flex items-center gap-2">
        <span
          class="w-3 h-3 rounded-full inline-block"
          [style.backgroundColor]="config?.colors?.[idx] || '#ffffff'"
        >
        </span>
        <span>{{ item?.label | transloco }}</span>
      </div>
    }
  }
</div>
